import { Component, Input } from '@angular/core';
import { IPortfolioDepositOut } from 'src/models/products.model';

@Component({
  selector: 'liberro-entry-fee-payment',
  standalone: false,
  templateUrl: './liberro-entry-fee-payment.component.html',
  styleUrl: './liberro-entry-fee-payment.component.less'
})
export class LiberroEntryFeePaymentComponent {
  @Input({ required: true }) public depositInfo!: IPortfolioDepositOut;
  @Input({ required: true }) public specificSymbol!: string;
  @Input({ required: true }) public amount!: number;
  @Input() public showHeader? = false;
}
